import React, { useMemo } from 'react';
import {
  Summarize as SummarizeIcon,
  Payments as PaymentsIcon,
  CheckCircle as CheckCircleIcon,
  Reply as ReplyIcon,
  SwapHoriz as SwapHorizIcon,
} from '@mui/icons-material';
import { StatusSummaryBar, type StatusSummaryMetric } from '../../../common/StatusSummaryBar';
import { POST_SALES_KPI } from '../../../../utils/constants/postSalesKpi';

export interface PostSalesCounts {
  total: number;
  pendientesDePago: number;
  completadas: number;
  devueltas: number;
  intercambios: number;
}

interface OrdersSummaryBarProps {
  counts: PostSalesCounts;
  loading?: boolean;
  /** Active post-sales KPI bucket (empty = none). */
  activeFilterValue?: string;
  onMetricClick?: (filterValue: string) => void;
}

export const OrdersSummaryBar: React.FC<OrdersSummaryBarProps> = ({
  counts,
  loading = false,
  activeFilterValue = '',
  onMetricClick,
}) => {
  const metrics: StatusSummaryMetric[] = useMemo(
    () => [
      {
        key: 'total',
        label: 'Total ventas',
        icon: <SummarizeIcon />,
        iconVariant: 'inventory',
        filterValue: '',
      },
      {
        key: 'completadas',
        label: 'Completadas',
        icon: <CheckCircleIcon />,
        iconVariant: 'sales',
        filterValue: POST_SALES_KPI.COMPLETED,
      },
      {
        key: 'pendientesDePago',
        label: 'Pendientes de pago',
        icon: <PaymentsIcon />,
        iconVariant: 'warning',
        filterValue: POST_SALES_KPI.PENDING_PAYMENT,
      },
      {
        key: 'devueltas',
        label: 'Devueltas',
        icon: <ReplyIcon />,
        iconVariant: 'availability',
        filterValue: POST_SALES_KPI.RETURNED,
      },
      {
        key: 'intercambios',
        label: 'Piezas intercambiadas',
        icon: <SwapHorizIcon />,
        iconVariant: 'inventory',
        filterValue: POST_SALES_KPI.EXCHANGED,
      },
    ],
    [],
  );

  return (
    <StatusSummaryBar
      metrics={metrics}
      counts={{
        total: counts.total,
        pendientesDePago: counts.pendientesDePago,
        completadas: counts.completadas,
        devueltas: counts.devueltas,
        intercambios: counts.intercambios,
      }}
      loading={loading}
      activeFilterValue={activeFilterValue}
      onMetricClick={onMetricClick}
    />
  );
};
